import cookie from 'react-cookies';

export const AGREEMENT_NUMBER = 'userId';

export const getAgreementNumber = (): string => {
    return cookie.load(AGREEMENT_NUMBER) || '';
};
